import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import NewSwitch from 'ui/atoms/NewSwitch/NewSwitch'
import { useOptimizationLogPreferenceTooltip } from '../../hooks/useOptimizationLogPreferenceTooltip'
import styles from './OptimizationLogPreferenceTooltip.module.less'

export function OptimizationLogPreferenceTooltip(): ReactNode {
  return <OptimizationLogPreferenceTooltipInner />
}
//TO BE REMOVED WHEN NEW OPTIMIZATION LOG IS FULLY RELEASED

function OptimizationLogPreferenceTooltipInner(): ReactNode {
  const { t } = useTranslation()
  const { open, isEnabled, handleMouseEnter, handleMouseLeave, handleTurnOn, handleTurnOff } =
    useOptimizationLogPreferenceTooltip()

  const handleSwitchClick = (value: string): void => {
    if (value === 'new') {
      handleTurnOn()
    } else {
      handleTurnOff()
    }
  }

  return (
    <div
      className={styles.OptimizationLogPreferenceTooltip}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <NewSwitch
        key={isEnabled ? 'new' : 'previous'}
        value={isEnabled ? 'new' : 'previous'}
        size="compact"
        variant="lighter"
        onClick={handleSwitchClick}
        items={[
          { value: 'previous', label: t('Previous') },
          { value: 'new', label: `${t('New')} ✦` },
        ]}
      />
      {open && (
        <div className={styles.OptimizationLogPreferenceTooltip_Popover}>
          <div className={styles.OptimizationLogPreferenceTooltip_Arrow} />
          <div className={styles.OptimizationLogPreferenceTooltip_Content}>
            <strong>{t('Try the new optimization log')}</strong>
            <p>
              {t(
                'More granular information per optimization. Switch here any time — the previous version stays available.'
              )}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
